<template>
  <card>
    <b-row align-v="center" slot="header" >
      <b-col cols="8">
        <h3 class="mb-0">Edit profile </h3>
      </b-col>
    </b-row>

    <b-form @submit.prevent="handleFormSubmit">
      <h6 class="heading-small text-muted mb-4">User information</h6>
        <div class="pl-lg-4">
        <b-row v-show="this.apiPath == 'update'">
          <b-col>
            <base-checkbox class="mb-3" v-model="user.isActive">
              Activate / Deactivate User
            </base-checkbox>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6">
            <base-input
              type="text"
              label="First Name"
              :placeholder="user.firstName"
              v-model="user.firstName"
            >
            </base-input>
          </b-col>
          <b-col lg="6">
            <base-input
              type="text"
              label="Last Name"
              :placeholder="user.lastName"
              v-model="user.lastName"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="6">
            <base-input
              type="text"
              :label="this.emaillabel"
              :placeholder="user.email"
              v-model="user.email"
            >
            </base-input>
          </b-col>
          <b-col lg="6">
            <base-input
              type="text"
              label="Job Title"
              :placeholder="user.title"
              v-model="user.title"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          
          <b-col lg="6">
            <base-input
              type="password"
              label="Password"
              autocomplete="new-password"
              v-model="user.password"
            >
            </base-input>
          </b-col>
          
          <b-col lg="6">
           <base-input label="User Role">
              <el-select v-model="user.securityLevel" v-if="user.securityLevel != null" placeholder="Select role">
                <el-option key="1" :value=1 label="User"></el-option>
                <el-option key="2" :value=2 v-if="currentUser.securityLevel > 1" label="Admin"></el-option>
                <el-option key="3" :value=3 v-if="currentUser.securityLevel > 2" label="Superadmin"></el-option>
                <el-option key="5" :value=5 label="Chef"></el-option>
              </el-select>
            </base-input>
          </b-col>
        </b-row>
      </div>
      <div v-show="this.apiPath == 'update'">
        <hr class="my-4">
        <!-- Address -->
        <h6 class="heading-small text-muted">Profile Image</h6>
        <p class="h5 font-weight-300 mb-4">Profile Images are cropped into a square. Recommended filesize is at least 200x200px.</p>
        <div class="pl-lg-4">
          <b-row>
            <b-col md="12">
              <div class="dropzone-icon">
               <div v-show="loadingProfileImage" class="loading">
                <loading-panel></loading-panel>
              </div>
                <vue2Dropzone
                  v-on:vdropzone-file-added="fileAdded"
                  v-on:vdropzone-max-files-exceeded="maxFileExceeded"
                  id="profileImage"
                  :options="dropzoneOptions"
                  v-show="!loadingProfileImage"
                  ref="profileImage"
                />
             </div>
          </b-col>
          </b-row>
        </div>
      </div>
      <div>
        <b-row>
          <b-col md="12">
          <base-button type="primary" native-type="submit" class="my-4">Save Info</base-button>
          </b-col>
        </b-row>
      </div>
    </b-form>
  </card>
</template>
<script>
import { Select, Option } from 'element-ui';
import BaseInput from '../../../components/Inputs/BaseInput.vue';
import LoadingPanel from '../../../components/LoadingPanel.vue';
import vue2Dropzone from 'vue2-dropzone'
import { apiClient } from '../../../_helpers';

export default {
  components: {
    vue2Dropzone,
    apiClient,
    LoadingPanel,
    BaseInput,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    user: Object,
    apiPath: ''
  },
  data() {
    return {
      pwdVisibility: false,
      loadingProfileImage: true,
      dropzoneOptions: {
        url: 'https://as-uw-marlin-whipstir-api.azurewebsites.net/api/assets/uploadfile',
        uploadMultiple: false,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        maxFiles: 1,
        maxFilesize: 256,
        maxThumbnailFilesize: 256,
        autoProcessQueue: false,
        addRemoveLinks: true,
        headers: {'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjNiNzFlNzZiLTc3Y2ItNDIxMy1hY2NmLTZkYzg3ZTIyMGJjNSIsImNvbXBhbnlpZCI6ImRjZDMzZDA3LTZkNzctNGZiOS04NmQ5LTBiOWNiNWE4ODE1OSIsImNsaWVudGlkIjoiMTFiZDc5NWYtMzFmYS00NmYyLWJjMzgtYmY1N2E1ZGU2YTFiIiwibmJmIjoxNjI0MDM0ODI5LCJleHAiOjE2MjQ2Mzk2MjksImlhdCI6MTYyNDAzNDgyOX0.Zuv_tqHUep9jCiTmbZDOUEnXHwHBvfeMbWlopwyw3gw'},
      }
    };
  },
  computed: {
    currentUser () {
      return this.$store.state.authentication.user.user
    },
    emaillabel() {
      if ( this.apiPath == 'addUser' ) {
        return "Email (If Empty, User Will Be Invited)";
      } 
      return "Email";
    },
    roles () {
      //if(this.currentUser.securityLevel == 1) {
      //  return ['User','Admin']
      //}
      return  ['User','Admin','SuperAdmin','API','Chef']
    }
  },
  methods: {
    loadProfileImage() {
      if (this.user.image) {
        var mockFile = { name: this.user.image.name, size: 50000, type: 'image', id: this.user.image.id};
        this.$refs.profileImage.manuallyAddFile(mockFile, this.user.image.absoluteUri);
      }
    },
    updateProfile() {
      this.sendNewUserData()
      .then(response => {
        if ( this.user.id == this.currentUser.id ) {
            this.refreshUserData(this.currentUser.id);
        } else {
          this.$router.push('/users');
        }
      })
    },
    handleFormSubmit() {
      if ( this.apiPath == 'addUser' ) {
        this.addUser(this.user)
      } else {
        this.editUser(this.user)
      }
    },
    async addUser(user) {
      
      if ( this.$refs.profileImage.dropzone.files[0] ) {
        this.user.imageUpload = this.$refs.profileImage.dropzone.files[0];
      }
      
      const response = await apiClient('users')
      .post('', `${JSON.stringify(user)}`)
      .then(response => {
        this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: `User successfully added`});
        this.$router.push({path: '/users'});
      });
    },
    async editUser(user) {
      if ( this.$refs.profileImage.dropzone.files[0] ) {
        this.user.imageUpload = this.$refs.profileImage.dropzone.files[0];
      }
      const { dispatch } = this.$store;
        await dispatch(`users/update`, user)
        .then(response => {
          this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: `User successfully updated`});
          this.$router.push({path: '/users'});
        })
        .catch(error => {
          return false
        });
    },
    refreshUserData(id) {
      setTimeout(() => {
          const currentRecipe = apiClient
            .get(`${process.env.VUE_APP_API_HOSTNAME}/api/users/${id}`)
            .then(response => {
              const { dispatch } = this.$store;
              dispatch('authentication/refreshUserData', response.data)
          });
      }, 2400);
    },
    maxFileExceeded(file) {
      this.$refs.profileImage.removeAllFiles()
      this.$refs.profileImage.addFile(file)
      this.profileImage = []
      this.profileImage.push(file)
    },
    fileAdded(file) {
      this.profileImage = []
      this.profileImage.push(file)
    }
  },
  created() {

    setTimeout(() => {
      this.loadProfileImage();
      this.loadingProfileImage = false;
    }, 1000);
  }
};
</script>
<style></style>
